document.getElementById("chat-action-open").onclick = function (event) {
    event.preventDefault();

    var url = "https://chat.digimobil.it/WFClient?WidgetType=WFClientChatWidget&CampaignID=da4dd630-206e-44d9-bb86-9629f2ee6e1e&Channel=www";
    var e, t = url;
    if (!e || e && e.closed) {
        var a = window.outerWidth - 400,
            n = Math.max(window.outerHeight / 2, 500);
        e = window.open(t, "ModalPopUp", "toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=400,height=" + n + ",left=" + a + ",top=300")
    }
};
